export default "__VITE_ASSET__DC53zC4u__"